import { combineReducers } from 'redux'
import { objectReducer, memberships as map } from 'utils'
import * as types from './types'

const emptyPrice = {
  value: '',
  currency: '',
  period: 'month',
}

const initial = {
  memberships: {
    gold: [1, 2, 3].map(e => ({ id: e, price: emptyPrice })),
    vip: { price: emptyPrice },
  },
  selected: { gold: { price: {} }, vip: null, chosen: false },
  meta: {
    reason: '',
    contactPhoneNumber: '',
  },
  loaded: false,
}

const memberships = objectReducer(types.FETCH_UPGRADE_DETAILS, initial.memberships, {
  success: data => map.many(data.subscriptions),
})

const selected = (state = initial.selected, action) => {
  if (action.type === types.FETCH_UPGRADE_DETAILS_SUCCESS && !state.gold.id) {
    return { ...state, gold: map.many(action.payload.subscriptions).gold?.[1] || {}, chosen: true }
  }
  if (action.type === types.SELECT_MEMBERSHIP) {
    return { ...state, ...action.data, chosen: true }
  }
  return state
}

const meta = (state = initial.meta, { type, payload }) => {
  if (type === types.FETCH_UPGRADE_DETAILS_SUCCESS) {
    return { reason: payload.reason, contactPhoneNumber: payload.contactPhoneNumber }
  }
  return state
}

const loaded = (state = initial.loaded, action) => (action.type === types.FETCH_UPGRADE_DETAILS_SUCCESS ? true : state)

export default combineReducers({ memberships, selected, meta, loaded })
